import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { ThemeContext } from 'styled-components'

import { Icon } from 'core/components'
import { isValidURL } from 'core/helpers'
import routes from 'core/routes'

import { TRootReducer } from 'store'

import {
  LeftContainer,
  RightContainer,
  UserAvatar,
  UserAvatarName,
  Wrapper,
  UserAvatarWrapper,
} from './styles'
import { HeaderProps } from './types'

function Header({
  user = {
    name: '',
    avatar: '',
  },
}: HeaderProps) {
  const location = useLocation()
  const { currentOrg } = useSelector((app: TRootReducer) => app.app)
  const { colors } = useContext(ThemeContext)

  const inUserProfilePage = location.pathname.endsWith(
    routes.app.console.userProfile,
  )
  const title = inUserProfilePage
    ? 'Toty - Perfil'
    : currentOrg && currentOrg.settings.name
  const userTitleAvailable = user.name ? user.name : user.phone || ''

  return (
    <Wrapper
      background={colors.primary}
      color={colors.foreground}
      style={{ boxShadow: 'none' }}
    >
      <LeftContainer>
        {currentOrg && (
          <img
            src={currentOrg.settings.brand}
            width={35}
            height={35}
            alt={currentOrg.settings.name}
            style={{ borderRadius: 5, marginRight: 10 }}
          />
        )}
        {title}
      </LeftContainer>
      <RightContainer>
        <UserAvatarWrapper>
          <span>{userTitleAvailable}</span>
          {isValidURL(user?.avatar) ? (
            <UserAvatar src={user.avatar} onClick={user.onClick} />
          ) : (
            <UserAvatarName onClick={user.onClick}>
              {userTitleAvailable ? (
                userTitleAvailable.substring(0, 1)
              ) : (
                <Icon icon="user" size="20px" />
              )}
            </UserAvatarName>
          )}
        </UserAvatarWrapper>
      </RightContainer>
    </Wrapper>
  )
}

export default Header
